module.exports = __webpack_public_path__ + "media/img/uploads/solutions-slant-commercial-ff9ba019c80730d3262574dbe974e215.jpg";